import { library } from '@fortawesome/fontawesome-svg-core'

import { faGlobe } from '@awesome.me/kit-428607b2fd/icons/sharp/light'

library.add(faGlobe)
